module.exports = __webpack_public_path__ + "img/22.179e2827.svg";